import type { FC, PropsWithChildren } from "react";
import { tv } from "tailwind-variants";

import { Flex } from "~/shared/ui-kit/flex/Flex";

export type CardProps = PropsWithChildren<{
  className?: string;
  variant?: "primary" | "secondary" | "tertiary";
}>;

const cardStyles = tv({
  base: "h-auto",
  variants: {
    variant: {
      primary: "rounded-lg md:bg-white/5 border-0 md:border md:border-white/20",
      secondary:
        "bg-[#401A75] shadow-[0px_0px_44px_0px_#140B1E66] backdrop-blur-[32px] border border-[#B476F066] items-center",
      tertiary:
        "bg-gradient-to-b from-[rgba(40,10,78,0.4)] to-[#280A4E] items-center",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});

export const Card: FC<CardProps> = ({ className = "", children, variant }) => {
  return (
    <Flex flexDirection="column" className={cardStyles({ variant, className })}>
      {children}
    </Flex>
  );
};
